import { createAppSupabase } from "@how/app-kit";
import { env } from "./env";

/** The single browser client for the control plane (publishable key, implicit flow, per-origin session). */
export const supabase = createAppSupabase(env);
